module.exports = __webpack_public_path__ + "static/img/home6.d196475.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/page/img/home6.jpg
// module id = /LGR
// module chunks = 0